export default "/images/vendor/flag-icon-css/flags/1x1/ci.svg?133adff8acf564df5728fc89b27fb81a";